import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getFaqDetailList = createAsyncThunk(
  "faqDetailList/getFaqDetailList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/faq/get_all_data`,
        data,

        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const faqDetailSlice = createSlice({
  name: "faqDetailList",
  initialState: {
    loading: false,
    faqDetailData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getFaqDetailList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFaqDetailList.fulfilled, (state, action) => {
        state.loading = false;
        state.faqDetailData = action.payload;
      })
      .addCase(getFaqDetailList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default faqDetailSlice.reducer;
